<template>
  <div class="loginForm">
    <form @submit.prevent="submitHandler">
      <input type="email" class="video-input" placeholder="Логин" v-model="email">
      <input type="password" class="video-input" placeholder="Пароль" v-model="password">
      <button type="submit" class="type-submit">Войти</button>
    </form>
  </div>
</template>

<script>
  import {mapActions, mapMutations} from 'vuex'
  export default {
    name: "Login",
    data() {
      return {
        email: '',
        password: ''
      }
    },
    methods: {
      ...mapActions('auth', ['Login', 'getUid']),
      ...mapMutations('auth', ['setUid']),
      async submitHandler() {
        const FormData = {email: this.email, password: this.password}
        try {
          await this.Login(FormData)
          const user = await this.getUid()
          this.setUid(user)
          this.$router.push('/admin/adminHistoryPage')
        } catch (e) {
          console.log(e)
        }
      }
    }
  }
</script>

<style lang="scss">
  .loginForm {
    input, textarea {
      border-radius: 4px !important;
      border: solid 1px #dee2ed !important;
      background-color: #ffffff !important;
    }
    display: flex;
    justify-content: center;
    height: calc(100vh - 82px);
    align-items: center;
    form {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      width: 450px;
      align-items: center;
      height: 200px;
      padding: 15px;
    }
  }
</style>